import type * as monacoTypes from 'monaco-editor';

export const BRACE_OPEN = '{{';
export const BRACE_CLOSE = '}}';
export const BRACE_OPEN_LENGTH = BRACE_OPEN.length;
export const BRACE_CLOSE_LENGTH = BRACE_CLOSE.length;

export const findOpeningBraces = (model: monacoTypes.editor.ITextModel, position: monacoTypes.Position) => {
  const line = model.getLineContent(position.lineNumber);
  const beforeCursor = line.substring(0, position.column - 1);
  const openIdx = beforeCursor.lastIndexOf(BRACE_OPEN);
  if (openIdx === -1) return null;
  // ensure there isn't a closing before the caret
  const between = beforeCursor.substring(openIdx + BRACE_OPEN_LENGTH);
  if (between.includes(BRACE_CLOSE)) return null;
  // 1-based column just after '{{'
  const startColumn = openIdx + 1 + 2;
  return { startColumn };
};

export const hasImmediateClosingBraces = (
  model: monacoTypes.editor.ITextModel,
  lineNumber: number,
  columnAfterWord: number,
) => {
  const line = model.getLineContent(lineNumber);
  // Check if there's }} immediately at or after the column (accounting for spaces)
  const afterWord = line.substring(columnAfterWord - 1);
  const trimmed = afterWord.trimStart();
  return trimmed.startsWith(BRACE_CLOSE);
};
